import { useEffect, useRef } from 'react'

import styles from './Alert.module.css'

export type AlertProps = {
  content: string
}

export const PhnxAlert: React.FC<AlertProps> = ({ content }) => {
  const alertRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const alert = alertRef.current
    if (!alert) return

    const handleScroll = () => {
      if (window.scrollY > alert.offsetTop) {
        alert.classList.add(styles['fixedContent'])
      } else {
        alert.classList.remove(styles['fixedContent'])
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  // if no content return null
  if (!content) return null

  return (
    <div className={styles['alert']} ref={alertRef} id="alert">
      <div className="container">
        <div className={styles['alert__content']}>{content}</div>
      </div>
    </div>
  )
}
